'use strict'

module.exports = {
  SET_FILTER: 'SET_FILTER',
  SET_SORT: 'SET_SORT',
  SET_IS_DURING_SAVE: 'SET_IS_DURING_SAVE',
  SET_IS_DATASET_READY: 'SET_IS_DATASET_READY',
  SET_FIXED_FILTER_ITEM: 'SET_FIXED_FILTER_ITEM'
}



// WEBPACK FOOTER //
// ./dataset-config/actionTypes.js